import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ModalActions } from '../../../actions/modal';
import DropDownButton from '../../ui/DropDownButton';
import NavBarMenuItem from '../../ui/NavBarMenuItem';
import CreateNewTasksModal from '../../modals/CreateNewTasks';

class QuickAddDropdownButton extends Component {
  static propTypes = {
    routing: PropTypes.string,
    user: PropTypes.instanceOf(Map),
    elementTypes: PropTypes.instanceOf(Map),
    userMode: PropTypes.string,
    dispatch: PropTypes.func,
  };

  state = {
    showCreateTaskModal: false,
  };

  getProjectMenuItems = () => {
    const { elementTypes, userMode } = this.props;
    return elementTypes
      .filter(
        elementType =>
          elementType.get('type') !== 'System' &&
          elementType.get('type') !== 'Work Breakdown Structure',
      )
      .reduce((prev, eleType) => {
        const adminOnly = eleType.getIn(
          ['props', '_global', '_adminCreate', '_value'],
          true,
        );
        const elementTypeId = eleType.get('id');
        const elementTypeName = eleType.get('type');
        const onClickHandler =
          elementTypeName === 'Task'
            ? this.toggleModal
            : this.handleClickNewType;

        const dataTestMap = {
          'Task': 'taskMenuItem',
          'Milestone': 'milestoneMenuItem',
          'Company': 'companyMenuItem',
        };

        if (userMode === 'admin' || (userMode === 'user' && !adminOnly)) {
          return prev.concat(
            <NavBarMenuItem
              key={elementTypeId}
              className="dropdown-item quick-add-by-type"
              onItemClick={onClickHandler}
              typeId={elementTypeId}
              title={elementTypeName}
              dataTest={dataTestMap[elementTypeName] || null}
            >
            {elementTypeName === 'Task' &&
              <CreateNewTasksModal
                showModal={this.state.showCreateTaskModal}
                handleCloseModal={this.toggleModal}
                contentLabel="Create New Task(s)"
                typeId={elementTypeId}
              />
            }
            </NavBarMenuItem>,
          );
        }

        return prev;
      }, []);
  };

  getMenuItems = () => {
    const { routing } = this.props;
    switch (routing) {
      case 'project':
        return this.getProjectMenuItems();
      default:
        return [];
    }
  };

  handleClick = (modalName, options) => {
    const { dispatch } = this.props;

    dispatch(
      ModalActions.toggleModal({
        name: modalName,
        options,
      }),
    );
  };

  handleClickNewType = typeId => {
    this.handleClick('CreateElementNewModal', {
      elementTypeId: typeId,
    });
  };

  toggleModal = () => {
    this.setState({ showCreateTaskModal: !this.state.showCreateTaskModal });
  };

  render() {
    const { icon } = this.props;

    return (
      <li className="nav-item nav-item-margin">dasdasdasdasd
        {
          <DropDownButton
            id="quick-add-btn"
            bClassName={'btn-success quickadd-dropdown'}
            title=""
            hideToggle
            icon={icon}
            dataTest="quickDropDown"
          >
            {this.getMenuItems()}
          </DropDownButton>
        }
      </li>
    );
  }
}

export default QuickAddDropdownButton;



// WEBPACK FOOTER //
// ./src/components/buttons/QuickAddDropdownButton/QuickAddDropdownButton.js